import React from 'react';
import { connect } from 'react-redux'
import IngresoCobranzas from './IngresoCobranzas';

//Importaci�n de actions.
import {
    changeDate,
    changeReferencia,
    changeImporte,
    aceptar,
    eliminar,
    actualizar,
    confirmar,
    denegar,
    editar,
    limpiar,
    seleccionarMoneda,
    resetState,
    getScreenData,
    expandirRow
} from '../actions/IngresoCobranzasActions';

//Mapeo del state
const mapStateToProps = (state) => {
    let result = {
        ingresoCobranzas: state.ingresoCobranzas,
        vistaCliente: state.vistaCliente.data,
        sesion: state.sesion
    }
}


//Mapeo de las actions en las props
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetState: () => {
            dispatch(resetState());
        },
        seleccionarMoneda: (monedaId) => {
            dispatch(seleccionarMoneda(monedaId));
        },
        getScreenData: (currentScope, currentAccount) => {
            dispatch(getScreenData(currentScope, currentAccount));
        },
        aceptar: (cobranza, accion, resetFields) => {
            dispatch(aceptar(cobranza, accion, resetFields));
        },
        eliminar: (cobranza, accion, resetFields) => {
            dispatch(eliminar(cobranza, accion, resetFields));
        },
        confirmar: (cobranza, accion, resetFields) => {
            dispatch(confirmar(cobranza, accion, resetFields));
        },
        denegar: (cobranza, accion, resetFields) => {
            dispatch(denegar(cobranza, accion, resetFields));
        },
        actualizar: (cobranza, accion, resetFields) => {
            dispatch(eliminar(cobranza, accion, resetFields));
        },
        editar: (cobranza) => {
            dispatch(editar(cobranza));
        },
        limpiar: () => {
            dispatch(limpiar());
        },
        expandirRow: (id) => {
            dispatch(expandirRow(id));
        },
        changeImporte: (importe) => {
            dispatch(changeImporte(importe));
        },
        changeReferencia: (referencia) => {
            dispatch(changeReferencia(referencia));
        },
        changeDate: (date) => {
            dispatch(changeDate(date));
        }
    }
}

//Connect entre el componente y las props y actions.
const IngresoCobranzasContainer = connect(mapStateToProps, mapDispatchToProps)(IngresoCobranzas);

export default IngresoCobranzasContainer;